<div class="container">
  <div *ngIf="isLoadingProgress">
    <progress-spinner></progress-spinner>
  </div>
  <div *ngIf="!isLoadingProgress">
    <div class="broadcast-discover-content" *ngIf="!showDiscoveryResponse && !savingInProgress">
      <div class="discovery-description">
        JMEPs not assigned an IP address can be discovered using a broadcast IP
            address. If you know the broadcast address you can enter it, or you can
            enter the subnet and we will find the broadcast address.
      </div>
      <div class="discover-content">
        <mat-card>
          <form name="broadcastDiscoveryForm">
            <div class="discover-options">
              <div class="option-items">
                <div class="title-row">
                  <div class="label-text">Broadcast Addresses</div>
                </div>
                <div class="item-text">
                  <textarea
                    rows="8"
                    cols="30"
                    name="ipAddresses"
                    [(ngModel)]="formData.ipaddress"
                    #ipAddressesInput="ngModel"
                    (ngModelChange)="onIpAddressChange()"
                    [disabled]="!readWriteRole"
                  ></textarea>
                  <div class="error">
                    <mat-error>
                      <div *ngFor="let ipaddressErrors of dataOptions.ipaddress.errorText">
                        {{ipaddressErrors}}
                      </div>
                    </mat-error>
                  </div>
                </div>
              </div>

              <div class="option-items">
                <div class="title-row">
                  <div class="label-text">Auto-Find Broadcast Addresses</div>
                </div>
                <div class="item-text subnet-container">
                  <div class="row-section">
                    <div class="input-container">
                      <div class="split-content">
                        <div class="label-text">Address</div>
                        <input
                          matInput
                          autocomplete="off"
                          type="text"
                          name="subnetAddr"
                          maxlength="11"
                          class="address-text"
                          [disabled]="!readWriteRole"
                          [(ngModel)]="subnetAddress"
                          #subnetAddrInput="ngModel"
                          (ngModelChange)="onSubnetChange()"/>
                        <span>.0</span>
                      </div>
                      <div class="split-content">
                        <div class="label-text">Mask</div>
                        <select
                          name="subnetAddressMask"
                          class="mask-dropdown"
                          [(ngModel)]="subnetAddressMask"
                          [disabled]="!readWriteRole"
                          (ngModelChange)="onSubnetChange()">
                          <option *ngFor="let masks of subnetAddressMaskOptions" [value]="masks">/{{masks}}</option>
                        </select>
                      </div>
                      <div class="split-content">
                        <md-button
                          class="mat-focus-indicator mat-flat-button mat-button-base add-btn"
                          (click)="addNewSubnetaAddress()"
                          [disabled]="!readWriteRole || dataOptions.subnet.error">
                          ADD
                        </md-button>
                      </div>
                    </div>
                    <div class="error">
                      <mat-error>
                        <div *ngFor="let subnetErrors of dataOptions.subnet.errorText">
                          {{subnetErrors}}
                        </div>
                      </mat-error>
                    </div>
                  </div>
                  <div class="list-container">
                    <ul>
                      <li *ngFor="let subnetAddress of dataOptions.subnet.data">
                        {{subnetAddress}}
                        <span ng-show="readWriteRole" (click)="removeSubnetaAddress($index)">
                          <i class="mdi mdi-close-circle-outline"></i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="discover-options next-row">
              <div class="option-items">
                <div class="title-row">
                  <div class="label-text">Transmit duration</div>
                </div>
                <div class="item-text">
                  <input
                    type="text"
                    class="text-dec"
                    name="timeToWait"
                    [(ngModel)]="formData.timeToWait"
                    #timeToWaitInput="ngModel"
                    (ngModelChange)="onTimeToWaitChange()"
                    [disabled]="!readWriteRole"
                  >
                  <span class="suffix">sec</span>
                  <div class="error">
                    <mat-error>
                      <div *ngFor="let timeToWaitErrors of dataOptions.timeToWait.errorText">
                        {{timeToWaitErrors}}
                      </div>
                    </mat-error>
                  </div>
                </div>
              </div>

              <div class="option-items auto-assign-ip">
                <div class="title-row">
                  <div class="label-text">Auto-configure</div>
                </div>
                <div class="item-text">
                  <mat-slide-toggle
                    #autoConfigureElement
                    name="performance"
                    [checked]="formData.autoConfigureOption"
                    class="enable-row"
                    color="primary"
                    (change)="autoConfigToggleChange(autoConfigureElement)"
                  ></mat-slide-toggle>
                  <span>
                    {{ formData.autoConfigureOption ? 'enabled' : 'disabled' }}
                  </span>
                  <span *ngIf="formData.autoConfigureOption" class="link-text" (click)="openAutoConfigureDialog()">{{editConfigLabel}}</span>
                </div>
              </div>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
    <div class="actions-message" *ngIf="savingInProgress">
      <mat-spinner [diameter]="75"></mat-spinner>
        <div class="discovery-status">Discovery in progress...
          <div class="progressTimeMsg">This may take up to 10 minutes</div>
          <div *ngIf="discoveryStatusResponseMessage" class="brodcast-status-msg">{{discoveryStatusResponseMessage}}</div>
        </div>
    </div>
    <div *ngIf="!savingInProgress && showDiscoveryResponse" class="discovery-res-container">
      <div
        *ngIf="discoveryResponseMessage"
        class="res-title"
        [ngClass]="{'no-result': !showDiscoveyResTable }">
        {{discoveryResponseMessage}}
      </div>
      <div *ngIf="showDiscoveyResTable">
        <div class="state-container">
          <div class="discovery-state" *ngFor="let states of discoveryStates">
            {{states.title}}
            <span class="count-val" [ngClass]="states.stateClass">{{states.count}}</span>
          </div>
        </div>
        <div class="discovery-table" *ngIf="discoveryTable?.columns?.length > 0">
          <viavi-table
            [tableConfigurations]="discoveryTable"
            [isActionEnabled]="isCheckBoxEnabled"
            [showToolbar]="false"
          ></viavi-table>
        </div>
      </div>
      <div class="error-msg-cont"
        *ngIf="discoveryResponseError && discoveryResponseStatus !== 'success'">
        <div class="res-title">Error in discovering JMEPs</div>
        <div class="res-err-msg">
          {{discoveryResponseError}}
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-action-cont" *ngIf="!isLoadingProgress && !savingInProgress">
    <button
      mat-button mat-raised-button
      color="primary"
      *ngIf="!savingInProgress && !showDiscoveryResponse"
      (click)="saveDiscoverDetails()"
      [disabled]="isValidAddress() || !readWriteRole"
    >START DISCOVERY</button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="showDiscoveryResponse"
      (click)="showDiscoverSetup()"
    >DISCOVERY SETUP</button>
    <button
      *ngIf="!savingInProgress && !showDiscoveryResponse"
      mat-button mat-raised-button
      class="plain-btn"
      (click)="onClearAllAddresses()"
    >CLEAR ALL ADDRESSES</button>
    <button
      *ngIf="!savingInProgress"
      mat-button  mat-raised-button
      class="plain-btn"
      (click)="closeModal()"
    >CLOSE</button>
  </div>
</div>
